import { createRoot } from 'react-dom/client'

import App from '@/App'
import { getEntraAuthorizeUrl } from '@/auth/entraConfig'
import { handleEntraRedirect } from '@/auth/handleEntraRedirect'
import '@/data/api/registerInterceptors'
import { clearTokens, hasExpiredEntraAccessToken, hasValidEntraAccessToken } from '@/data/api/token'
import { useAuthStore } from '@/store/authStore'
import '@/styles/index.css'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Failed to find the root element')
}

const root = createRoot(rootElement)

const boot = async () => {
  await handleEntraRedirect()

  if (hasExpiredEntraAccessToken()) {
    clearTokens()
  }

  if (!hasValidEntraAccessToken() || !useAuthStore.getState().isAuthenticated) {
    window.location.assign(await getEntraAuthorizeUrl())
    return
  }

  root.render(<App />)
}

void boot()
